import React from 'react';
import './Logo.scss';
import { useSelector } from 'react-redux';
import { triggerDataLayerOnCtaClick } from '../../../../own-days/helper';

const Logo = () => {
  const logo = useSelector(state => state?.header?.mainNavigationData?.logo);

  const onClickLogo = () => {
    // CLEVERTAP_EVENT
  };

  if (logo) {
    return (
      <a href={logo.link} onClick={() => triggerDataLayerOnCtaClick('logo')}>
        <img alt={logo.alt} className="odLogo" src={logo.src} onClick={onClickLogo} />
      </a>
    );
  }

  return null;
};

export default Logo;
